<div class="row">
    <div class="col-sm-12">
      <h3 class="sub-title alert alert-info">Subjects</h3></div>

  </div>
<div class="table-responsive" *ngIf="subjectList.length>0">
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Country</th>
    <th>Level</th>
    <th>Name</th>

    <th>Billing Code</th>
    <th>Syllabus</th>
    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let subject of subjectList;">
        <td>{{subject.countryName}}</td>
        <td>{{subject.level}}</td>
        <td>{{subject.name}}</td>

        <td>{{subject.billingCode}}</td>
        <td>
          <a [routerLink]="['/admin/syllabus/show',subject.server_syllabus_id]">
          {{subject.syllabusCode}}
        </a>
        </td>
    </tr>

    </tbody>

</table>
</div>
<app-spinner *ngIf="(subjectList.length==0) && loading"></app-spinner>
<div *ngIf="(subjectList.length==0) && !loading" class="text-center">No Records Found </div>

